'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var luxon = require('luxon');
var CheckCircleIcon = require('@material-ui/icons/CheckCircle');
var CancelIcon = require('@material-ui/icons/Cancel');
require('../../ThemeProvider/ThemeProvider.js');
var colors = require('../../ThemeProvider/colors.js');
require('../../ThemeProvider/theme.js');
var reactNumberFormat_es = require('../../node_modules/react-number-format/dist/react-number-format.es.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var CheckCircleIcon__default = /*#__PURE__*/_interopDefaultLegacy(CheckCircleIcon);
var CancelIcon__default = /*#__PURE__*/_interopDefaultLegacy(CancelIcon);

function renderCell(type, value) {
  switch (type) {
    case 'currency':
      {
        return /*#__PURE__*/React__namespace.createElement(reactNumberFormat_es, {
          prefix: "$",
          displayType: "text",
          value: value,
          thousandSeparator: ",",
          fixedDecimalScale: true,
          decimalScale: 2
        });
      }

    case 'number':
      {
        return /*#__PURE__*/React__namespace.createElement(reactNumberFormat_es, {
          displayType: "text",
          value: value,
          thousandSeparator: ",",
          decimalScale: 2
        });
      }

    case 'datetime':
      {
        return luxon.DateTime.fromISO(value).toLocaleString(luxon.DateTime.DATETIME_SHORT);
      }

    case 'date':
      {
        return luxon.DateTime.fromISO(value).toLocaleString(luxon.DateTime.DATE_SHORT);
      }

    case 'bool':
      {
        return value ? /*#__PURE__*/React__namespace.createElement(CheckCircleIcon__default['default'], {
          style: {
            color: colors.colors.green[500]
          }
        }) : /*#__PURE__*/React__namespace.createElement(CancelIcon__default['default'], {
          style: {
            color: colors.colors.red[500]
          }
        });
      }

    case 'string':
      {
        var _value$toString;

        return (_value$toString = value === null || value === void 0 ? void 0 : value.toString()) !== null && _value$toString !== void 0 ? _value$toString : '';
      }

    default:
      {
        return '';
      }
  }
}

exports.default = renderCell;
exports.renderCell = renderCell;
